import { __module as t } from "./index126.js";
var i;
function p() {
  return i ? t.exports : (i = 1, typeof Object.create == "function" ? t.exports = function(e, r) {
    r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : t.exports = function(e, r) {
    if (r) {
      e.super_ = r;
      var o = function() {
      };
      o.prototype = r.prototype, e.prototype = new o(), e.prototype.constructor = e;
    }
  }, t.exports);
}
export {
  p as __require
};
//# sourceMappingURL=index115.js.map
